import { DialogActions, DialogContent, DialogContentText } from "@mui/material";
import StyledButtonPrimaryMini from "components/StyledButtonPrimaryMini";
import StyledButtonSecondaryMini from "components/StyledButtonSecondaryMini";
import { FormattedMessage } from "react-intl";
import { DialogComponentProps } from "../dialogStack";

interface Props extends DialogComponentProps<boolean> {
  message: string;
}

export default function ConfirmDialog({ message, onClose }: Props) {
  return (
    <>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{ height: 60, pl: 2, pr: 2, pt: 0 }}
        style={{ justifyContent: "space-evenly" }}
      >
        <StyledButtonPrimaryMini onClick={() => onClose(true)}>
          <FormattedMessage id={"general.yes"} />
        </StyledButtonPrimaryMini>
        <StyledButtonSecondaryMini onClick={() => onClose(false)}>
          <FormattedMessage id={"general.cancel"} />
        </StyledButtonSecondaryMini>
      </DialogActions>
    </>
  );
}
